import { Injectable } from '@angular/core';
import { AssortmentTreeNavigationConfigService } from 'gung-standard';
import { SjoborgConceptTreeListComponent } from '../components/sjoborg-concept-tree-list/sjoborg-concept-tree-list.component';
import { SjoborgProductDetailsComponent } from '../components/sjoborg-product-details/sjoborg-product-details.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgAssortmentTreeNavigationConfigService extends AssortmentTreeNavigationConfigService {
  getProductDetailLayout(): any {
    return SjoborgProductDetailsComponent;
  }

  getConceptLayout() {
    return SjoborgConceptTreeListComponent;
  }
}
